import React from 'react';
import BundleCard from './BundleCard';

/**
 * A wrapper around the Alcat bundle selection UI that displays a list of available bundles in a grid layout.
 */
const BundleContainer = ({ bundles, onSelect, selections }) => {
	if (!bundles?.length) {
		return null;
	}

	const popularCombinations = bundles.filter((bundle) => !bundle.customProfile);
	const customProfiles = bundles.filter((bundle) => bundle.customProfile);

	// Move the subtitle to the top when both groups are displayed
	const subtitle = <p>Choose from predefined configurations, or build your own Alcat Test panel below.</p>;
	const hasCustomProfiles = customProfiles.length > 0;

	return (
		<>
			{hasCustomProfiles && subtitle}
			<BundleGroup title="Custom Profiles" bundles={customProfiles} onSelect={onSelect} selections={selections} />
			<BundleGroup
				title="Popular Combinations"
				subtitle={!hasCustomProfiles && subtitle}
				bundles={popularCombinations}
				onSelect={onSelect}
				selections={selections}
			/>
		</>
	);
};

/**
 * Convenience component to separate Custom Profiles and Popular Combinations
 */
const BundleGroup = ({ title, subtitle, bundles, onSelect, selections }) => {
	if (!bundles?.length) {
		return null;
	}
	return (
		<div>
			<h4 className="mb-2 text-black">{title}</h4>
			{subtitle}
			<div className="css-product-grid mt-3">
				{bundles.map((bundle) => (
					<BundleCard key={bundle.id} bundle={bundle} onSelect={onSelect} selections={selections} />
				))}
			</div>
		</div>
	);
};

export default BundleContainer;
